import { addToCartButtonStyles as addToCartStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { addToListLinkStyles as addToListStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { quantityOrderedStyles as qtyStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

qtyStyles.quantityOrdered = {
    ...qtyStyles.quantityOrdered,
    mergeCss: true,
    label: null,
    cssOverrides: {
        ...qtyStyles.quantityOrdered?.cssOverrides,
        formField: css``,
        inputSelect: css`
            ${qtyStyles.quantityOrdered?.cssOverrides?.inputSelect}
            color: ${getColor(colorStrings.commonGlobalDarkerGray)};
        `,
    },
};

addToCartStyles.button = {
    ...addToCartStyles.button,
    mergeCss: true,
    css: css`
        ${addToCartStyles.button?.css}
        ${mediaQueriesBP.minMD} {
            max-width: 125px;
        }
    `,
    typographyProps: {
        ...addToCartStyles.button?.typographyProps,
        lineHeight: "16px",
    },
};

addToListStyles.wrapper = {
    css: css``,
};

availabilityStyles.availability = {
    ...availabilityStyles.availability,
    messageText: {
        ...availabilityStyles.availability?.messageText,
        color: colorStrings.commonGlobalIce,
        weight: 600,
    },
    container: {
        css: css`
            ${availabilityStyles.availability?.container?.css}
            margin: 10px 0;
        `,
    },
};
